import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-carousel-card',
  imports: [NgOptimizedImage, NgScrollbarModule],
  templateUrl: './carousel-card.component.html',
  styleUrl: './carousel-card.component.scss'
})
export class CarouselCardComponent {
  assetsCDNUrl = environment.assetsCDNUrl;
  moveValue: number = 0;
  currentSlide: any = 0;
  previousSlide: number = 6;
  nextSlide: number = 0;
  cardData = [
    {
      imgUrl: '/assets/images/imageSlider/slider1.webp',
      subTitle: 'A Legacy Of Trust',
      titletext: 'A Foundation You Can Rely On',
      description: "Drawing on 50+ years of expertise from Shriram Group, and Sanlam Group's 100+ years of global leadership."
    },
    {
      imgUrl: '/assets/images/imageSlider/slider2.webp',
      subTitle: 'Personalized for You',
      titletext: 'Strategies For Every Financial Goal',
      description: 'Crafting solutions aligned with your unique aspirations.'
    },
    {
      imgUrl: '/assets/images/imageSlider/slider3.webp',
      subTitle: 'Unmatched Attention, Always',
      titletext: 'Care for Every Detail',
      description: 'Providing solutions for your financial needs at every stage.'
    },
    {
      imgUrl: '/assets/images/imageSlider/slider4.webp',
      subTitle: 'Value That Grows',
      titletext: 'Wealth That Builds A Legacy',
      description: 'Managing wealth for generations.'
    },
    {
      imgUrl: '/assets/images/imageSlider/slider5.webp',
      subTitle: 'Research-Backed Solutions',
      titletext: 'Where Expertise Meets Integrity',
      description: 'Offering solutions backed by institutional research.'
    },
    {
      imgUrl: '/assets/images/imageSlider/slider6.webp',
      subTitle: 'Empathy Above All',
      titletext: 'Supporting Every Unique Journey',
      description: 'Helping you make informed decisions.'
    }
  ];

  handler_slider(elem: any) {
    if (typeof window != 'undefined') {
      let slidesParent = elem.target.closest('.carouselCard-wrap');
      let slides = slidesParent.querySelectorAll('.carouselCard');
      let currenSlidess = elem.target.getAttribute('id').split('-')[1];
      slides.forEach((ele: any) => {
        ele.classList.remove('active');
      });
      elem.target.classList.add('active');
      this.currentSlide = parseInt(currenSlidess);
      if (this.currentSlide > 0) {
        document.getElementById('slider-prev')?.classList.remove('disable');
      }
      if (this.currentSlide == 0) {
        document.getElementById('slider-prev')?.classList.add('disable');
      }
      if (this.currentSlide > 4) {
        document.getElementById('slider-next')?.classList.add('disable');
      } else {
        document.getElementById('slider-next')?.classList.remove('disable');
      }
      this.handler_sliderMove(this.currentSlide);
    }
  }

  handler_sliderMove(slide: any) {
    if (typeof window != 'undefined') {
      if (window.innerWidth > 767) {
        let sliderParent = document.getElementById('js-carouselCard-wrap') as HTMLDivElement;
        sliderParent.style.transition = 'all 0.40s linear';
        if (this.nextSlide < slide) {
          if (window.innerWidth > 1199) {
            this.moveValue += 80;
          } else {
            this.moveValue += 100;
          }
          sliderParent.style.transform = `translateX(${-this.moveValue}px)`;
        } else if (this.previousSlide > slide) {
          if (window.innerWidth > 1199) {
            this.moveValue -= 80;
          } else {
            this.moveValue -= 100;
          }
          sliderParent.style.transform = `translateX(${-this.moveValue}px)`;
        }
        this.previousSlide = slide;
        this.nextSlide = slide;
      }
    }
  }

  handler_sliderNext(event: any, action: any) {
    if (typeof window != 'undefined') {
      let slides = document.querySelectorAll('.carouselCard');
      if (action == 'next') {
        if (this.currentSlide <= slides.length - 2) {
          slides.forEach((ele: any) => {
            ele.classList.remove('active');
          });
          document.getElementById(`slide-${this.currentSlide + 1}`)?.classList.add('active');
          this.currentSlide++;
          this.handler_sliderMove(this.currentSlide);
        }
        if (this.currentSlide > 0) {
          document.getElementById('slider-prev')?.classList.remove('disable');
        }
        if (this.currentSlide > 4) {
          document.getElementById('slider-next')?.classList.add('disable');
        }
      } else {
        if (this.currentSlide > 0) {
          if (this.currentSlide == 1) {
            document.getElementById('slider-prev')?.classList.add('disable');
          }
          if (this.currentSlide > 3) {
            document.getElementById('slider-next')?.classList.remove('disable');
          }
          slides.forEach((ele: any) => {
            ele.classList.remove('active');
          });
          document.getElementById(`slide-${this.currentSlide - 1}`)?.classList.add('active');
          this.currentSlide--;
          this.handler_sliderMove(this.currentSlide);
        }
      }


    }
  }
}